export default __webpack_public_path__ + "static/media/1916.154b6b97.png";